import ZoneHeadCoordinatorList from '../../features/zoneHead/ZoneHeadCoordinatorList'

const ZoneHeadCoordinatorListPage = () => {
    return (
        <ZoneHeadCoordinatorList />
    )
}

export default ZoneHeadCoordinatorListPage